<template>
  <section class="sku_section sku-number">
    <div class="section_title">
      <span class="title">购买数量</span>
      <div class="content">
        <span
          class="operate operate--minus"
          :class="{ 'operate--disabled': number <= 1 }"
          @click="addNum(false)"
          :aria-label="`数量减1，按钮，${number <= 1 ? '已停用' : '可减少购买数量'}`"
          tabindex="0"
        ></span>
        <span class="value fs-42" :aria-label="`商品数量${number}件`" @click="showNumInput">{{ number }}</span>
        <span
          class="operate operate--add"
          :class="{ 'operate--disabled': number >= maxNum }"
          @click="addNum(true)"
          :aria-label="`数量加1，按钮，${number >= maxNum ? '已停用' : '可增加购买数量'}`"
          tabindex="0"
        ></span>
      </div>
    </div>
    <template v-if="enableInput">
      <v-os-popup
        class="sku-input-num-popup"
        title="请输入数量"
        container="body"
        v-model="inputPopupShow"
        :minHeightFill="false"
        @close="inputPopupShow = false"
        :footerShow="true"
        @footerClick="checkInputNum"
      >
        <nx-input-item
          class="sku-num-input"
          type="digit"
          align="center"
          :isFormative="true"
          :formation="
            (name, val, pos) => {
              return val.replace(/[^0-9]/gi, '')
            }
          "
          caretColor="#f10313"
          v-model="inputNum"
          placeholder="请输入数量"
        ></nx-input-item>
      </v-os-popup>
    </template>
  </section>
</template>

<script>
import { InputItem } from '@vivo/vos-ui'
export default {
  name: 'SkuNumber',
  components: {
    [InputItem.name]: InputItem
  },
  props: {
    skuInfo: Object,
    number: Number,
    maxNum: Number,
    enableInput: Boolean
  },
  data() {
    return {
      // 防重点
      isDoing: false,
      inputPopupShow: false,
      inputNum: 1
    }
  },
  watch: {
    maxNum(val) {
      // 活动和正常购买以及拼团的数量限制不一致，number要重置
      if (val < this.number) {
        this.$emit('numberChange', 1)
      }
    }
  },
  methods: {
    // 调整购买数量
    addNum(isAdd) {
      // 至少购买一件
      if (!isAdd && this.number <= 1) {
        // do nothing
      } else if (isAdd && this.number >= this.maxNum) {
        if (this.isDoing) {
          return
        }
        this.isDoing = true
        // 延时恢复标志位
        setTimeout(() => {
          this.isDoing = false
        }, 2000)
        // 数量不能超过后台规定数量
        this.$toast(`商品最多只能选中${this.maxNum}个`)
      } else {
        this.$emit('numberChange', isAdd ? this.number + 1 : this.number - 1)
      }
    },
    // 弹出数量输入弹层
    showNumInput() {
      if (!this.enableInput) return
      this.inputNum = this.number
      this.inputPopupShow = true
    },
    checkInputNum() {
      if (this.inputNum <= 0) {
        this.$toast('最少购买1件')
        this.inputNum = 1
        return
      }
      if (this.inputNum > this.maxNum) {
        this.$toast('超过限购数量')
        this.inputNum = this.maxNum
        return
      }
      this.inputPopupShow = false
      this.$emit('numberChange', +this.inputNum)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
